export default "assets/images/icons/slider-arrow-881770c5.svg";